import axios from "axios";

const instance = axios.create({
    baseURL: 'https://landhotel-ossig.shopware-dresden.de/wp-json/'
});

export default instance;